var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFFilter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#008060",
  d: "M9 1.285c-1.288 0-7.714.109-7.714 2.25v2.133c0 .574.253 1.114.694 1.482l5.091 4.24v4.68a.644.644 0 0 0 1.029.515l2.314-1.735c.322-.242.515-.626.515-1.03v-2.43l5.091-4.24c.44-.368.694-.908.694-1.482V3.535c0-2.141-6.426-2.25-7.714-2.25m0 1.286c3.593 0 5.755.583 6.328.964-.573.381-2.735.964-6.328.964s-5.755-.583-6.328-.964c.573-.381 2.735-.964 6.328-.964"
})));
export { SvgFFilter as ReactComponent };
export default __webpack_public_path__ + "static/media/f-filter.3723a1fb.svg";